// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/numericutils/v1/values.proto (package chalk.numericutils.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/numericutils/v1/values.proto.
 */
export const file_chalk_numericutils_v1_values: GenFile = /*@__PURE__*/
  fileDesc("CiJjaGFsay9udW1lcmljdXRpbHMvdjEvdmFsdWVzLnByb3RvEhVjaGFsay5udW1lcmljdXRpbHMudjEiRAoMTnVtZXJpY1ZhbHVlEhMKCWludF92YWx1ZRgBIAEoA0gAEhYKDGRvdWJsZV92YWx1ZRgCIAEoAUgAQgcKBXZhbHVlYgZwcm90bzM");

/**
 * NumericValue keeps exact producers exact: int64 for counts and integer columns, double for
 * averages and percentiles, rather than rounding everything through a double.
 *
 * @generated from message chalk.numericutils.v1.NumericValue
 */
export type NumericValue = Message<"chalk.numericutils.v1.NumericValue"> & {
  /**
   * @generated from oneof chalk.numericutils.v1.NumericValue.value
   */
  value: {
    /**
     * @generated from field: int64 int_value = 1;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * @generated from field: double double_value = 2;
     */
    value: number;
    case: "doubleValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.numericutils.v1.NumericValue.
 * Use `create(NumericValueSchema)` to create a new message.
 */
export const NumericValueSchema: GenMessage<NumericValue> = /*@__PURE__*/
  messageDesc(file_chalk_numericutils_v1_values, 0);

